import dynamic from 'next/dynamic';
import type { FC } from 'react';
import { RenderComponents } from '@/Module/Core/Component';
import type { IProps } from '@/Module/Core/Model/DataModel';
const DesktopComponent = dynamic(() => import('./DefaultLayoutDesktop'));
const MobileComponent = dynamic(() => import('./DefaultLayoutMobile'));
const DefaultLayout: FC<IProps> = props => {
  return <RenderComponents DesktopComponent={DesktopComponent} MobileComponent={MobileComponent} {...props} data-sentry-element="RenderComponents" data-sentry-component="DefaultLayout" data-sentry-source-file="DefaultLayout.tsx" />;
};
export default DefaultLayout;